var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.39856 31.6321C0.39856 33.4425 1.78583 34.8506 3.56945 34.8506H26.8227C28.5403 34.8506 29.9936 33.4425 29.9936 31.6321V13.3942H0.39856V31.6321ZM4.62642 18.7583C4.62642 18.2219 5.08884 17.6855 5.68338 17.6855H12.0252C12.5537 17.6855 13.0821 18.2219 13.0821 18.7583V25.1952C13.0821 25.7987 12.5537 26.2681 12.0252 26.2681H5.68338C5.08884 26.2681 4.62642 25.7987 4.62642 25.1952V18.7583ZM26.8227 4.81166H23.6518V1.59321C23.6518 1.0568 23.1233 0.520386 22.5948 0.520386H20.4809C19.8864 0.520386 19.4239 1.0568 19.4239 1.59321V4.81166H10.9682V1.59321C10.9682 1.0568 10.4397 0.520386 9.91124 0.520386H7.79731C7.20277 0.520386 6.74035 1.0568 6.74035 1.59321V4.81166H3.56945C1.78583 4.81166 0.39856 6.28679 0.39856 8.03012V11.2486H29.9936V8.03012C29.9936 6.28679 28.5403 4.81166 26.8227 4.81166Z",
    fill: "#1D2A30"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.e7712683.svg";
export { ForwardRef as ReactComponent };